/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import AgcKosokuryoTarihuService from "../../../service/billing/agcKosokuryoTarihu/agcKosokuryoTarihuService"
import {
  TAgcKosokuryoTarihuGetListRes,
  TAgcKosokuryoTarihuPutReq,
} from "../../../service/billing/agcKosokuryoTarihu/TAgcKosokuryoTarihu"

import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { TApiResponse } from "../../../service/TApiResponse"
import SyohizeiKanriService from "../../../service/master/syohizeiKanri/syohizeiKanriService"
import { TSyohizeiKanriListGetReq } from "../../../service/master/syohizeiKanri/TSyohizeiKanri"
import { RootState } from "../../../globalStore/rootreducer"
import util from "../../../ts/util"
import { useGridEventHandler } from "../../../ts/hooks/useGridEventHandler"

export type TAGC高速料GridItem = TAgcKosokuryoTarihuGetListRes & {
  row_id: symbol
}

/**
 * AGC鹿島高速料タリフ
 * @returns
 */
const AGCKosokuryoTarihuRegister = () => {
  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  const 営業日 = useSelector((state: RootState) => state.date.eigyobiStr)
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "AGCKosokuryoTarihuRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TAgcKosokuryoTarihuGetListRes | TAGC高速料GridItem>,
    pageSize: number
  ) => {
    const newData: TAGC高速料GridItem[] = data.map((d) => {
      return { ...d, row_id: Symbol() }
    })
    return new wjCore.CollectionView(newData, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      newItemCreator() {
        return {
          AGC高速料マスタID: null,
          高速料記号: "",
          請求理由: "",
          高速代請求区間: "",
          高速料税抜: null,
          高速料税込: null,
          備考: "",
          更新日時: "",
          row_id: Symbol(),
        } as unknown as TAGC高速料GridItem
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    try {
      const res = await new AgcKosokuryoTarihuService().getList()
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // 正常に検索した場合に検索完了フラグ制御
      flexGrid!.isReadOnly = false
      setGridData({
        data: createCollectionView(res.data, pageSize),
      })
    } catch (error) {
      dispatch(setAlerts(error))
      if (flexGrid) {
        flexGrid.isReadOnly = true
      }
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.pastingCell.addHandler(beginningEdit)
    grid.refresh()
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    const targetRow = e.getRow()
    const dataItem: TAGC高速料GridItem = targetRow.dataItem
    // 高速料記号に関して高速料IDがある＝登録済みの場合は編集不可
    switch (col.binding as keyof TAGC高速料GridItem) {
      case "高速料記号":
        if (dataItem.AGC高速料マスタID) {
          e.cancel = true
        }
        break
    }
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    // if (ref明細フォーマットフラグ.current) return
    // AddNew行を除いてデータ行がある場合に登録ボタン制御
    if (f.rows.length > 1) {
      setIsSubmitButton(true)
    } else {
      setIsSubmitButton(false)
    }

    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      const targetRow = e.getRow()
      const dataItem: TAGC高速料GridItem = targetRow.dataItem
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        if (cellBinding === "高速料記号") {
          if (dataItem.AGC高速料マスタID) {
            wjCore.toggleClass(e.cell, "read-only-cell", true)
          } else if (
            高速料記号エラーList.current != null &&
            高速料記号エラーList.current.length > 0
          ) {
            const isErrorCell = 高速料記号エラーList.current.find(
              (d) => d === dataItem.row_id
            )
              ? true
              : false
            wjCore.toggleClass(e.cell, "data-warning", isErrorCell)
          }
        }
      }
    }
    // フォーマットのループ制御
    // ref明細フォーマットフラグ.current = true
  }

  const cellEditEndedHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const column = f.getColumn(e.col)
    const dataItem: TAGC高速料GridItem = f.rows[e.row]?.dataItem

    switch (column.binding as keyof TAGC高速料GridItem) {
      case "高速料税込":
        if (dataItem) {
          dataItem.高速料税抜 = util.get消費税抜額(
            dataItem.高速料税込,
            消費税率
          )
        }
        break
      default:
        break
    }
  }

  const pastedCellHandler = cellEditEndedHandler

  const beforeSubmit = () => {
    clearError()
    let messages: string[] = []
    let isError = false
    // フォーマットチェック
    const フォーマットValid = フォーマットvalidate()
    isError = フォーマットValid.hasError === true ? true : isError
    messages.push(...フォーマットValid.messages)

    if (isError) {
      dispatch(setWarningAlerts(messages))
      flexGrid?.refresh()
      return
    }
    setIsConfirmModalShow(true)
  }

  /**
   * エラークリア
   */
  const clearError = () => {
    dispatch(clearAlert())
  }

  const フォーマットvalidate = () => {
    let 高速料記号エラー = false
    const エラーメッセージList: string[] = []

    const gridItems: TAGC高速料GridItem[] = gridData.data.items
    gridItems.forEach((d) => {
      if (3 < d.高速料記号.length) {
        if (!高速料記号エラー) {
          高速料記号エラー = true
          エラーメッセージList.push("高速料記号は3文字以内で入力して下さい。")
        }
        高速料記号エラーList.current.push(d.row_id)
      }
    })
    return {
      hasError: 高速料記号エラー,
      messages: エラーメッセージList,
    }
  }

  /**
   * 更新処理
   */
  const submit = async () => {
    const putList: TAgcKosokuryoTarihuPutReq[] = []
    let upsertData: TAgcKosokuryoTarihuGetListRes[] = gridData.data.items
    upsertData.forEach((r) => {
      let putData: TAgcKosokuryoTarihuPutReq = {
        AGC高速料マスタID: r.AGC高速料マスタID ?? undefined,
        高速料記号: r.高速料記号,
        請求理由: r.請求理由,
        高速代請求区間: r.高速代請求区間,
        高速料税抜: r.高速料税抜,
        高速料税込: r.高速料税込,
        備考: r.備考,
        更新日時: r.更新日時,
      }
      putList.push(putData)
    })
    try {
      const res = await new AgcKosokuryoTarihuService().putList(putList)
      if (res) {
        isPrompt.current = false
        showInfoToast(`AGC高速料の更新が完了しました`)
        search()
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 削除
   */
  const deleteRow = async () => {
    try {
      const service = new AgcKosokuryoTarihuService()
      let res: TApiResponse<boolean>
      if (deleteID) {
        res = await service.delete(deleteID.toString(), {
          更新日時: delete更新日時,
        })
        if (res) {
          isPrompt.current = false
          showInfoToast(`削除が完了しました。`)
          search()
        }
      } else {
        dispatch(setWarningAlerts(["AGC高速料情報が登録されていません。"]))
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsDeleteRowConfirmModalShow(false)
    }
  }

  // 消費税率の取得
  const get消費税率 = async () => {
    const param: TSyohizeiKanriListGetReq = {
      適用日: 営業日,
      削除済み包含フラグ: false,
    }

    try {
      const res = await new SyohizeiKanriService().getList(param)

      if (res.data == null || res.data.length <= 0) {
        set消費税率(0)
      } else {
        set消費税率(res.data[0].消費税率 ?? 0)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [消費税率, set消費税率] = useState<number>(0)

  // TODO:AGCの荷主固定。確定したら置き換える。
  const [isDeleteRowConfirmModalShow, setIsDeleteRowConfirmModalShow] =
    useState(false)
  const [deleteID, setDeleteID] = useState<number>()
  const [delete更新日時, setDelete更新日時] = useState<string>("")
  // エラーチェック用
  const 高速料記号エラーList = useRef<Symbol[]>([])
  //#endregion

  //#region [effect]

  useEffect(() => {
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      // 全部取得するので、ロード完了後に無条件でリスト取得処理
      search()
        .then(async () => {
          await get消費税率()
        })
        .finally(() => {
          dispatch(画面ロック解除())
        })
    }
  }, [gridInitialized])

  // イベント付替え用のhookに格納する
  const cellEditEndedHandlerHooks = useGridEventHandler(
    flexGrid?.cellEditEnded,
    cellEditEndedHandler
  )
  const pastedCellHandlerHooks = useGridEventHandler(
    flexGrid?.pastedCell,
    pastedCellHandler
  )

  // 消費税率更新のタイミングでcellEditEndedを更新する
  useEffect(() => {
    cellEditEndedHandlerHooks.refresh()
    pastedCellHandlerHooks.refresh()
  }, [flexGrid, 消費税率])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      dispatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">AGL鹿島ガラス高速料タリフ</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                }
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                isShowGridFooter={false}
                pageSize={pageSize}
                setPageSize={setPageSize}
                style={{ height: "Auto", maxHeight: "60rem" }}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                gridProperties={{
                  isReadOnly: false,
                  allowMerging: "ColumnHeaders",
                  allowDragging: wjcGrid.AllowDragging.None,
                }}
                headerComponent={
                  <>
                    <div>
                      <Button
                        type="button"
                        className="ms-4"
                        disabled={!isSubmitButton}
                        onClick={() => {
                          search()
                        }}>
                        再取得
                      </Button>
                    </div>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  binding="高速料記号"
                  isRequired={false}
                  width={100}
                  header="高速料記号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="請求理由"
                  isRequired={false}
                  width={500}
                  header="請求理由"></wjrGrid.FlexGridColumn>
                {/* 2023/02/01時点では不要となったため非表示 */}
                {/* 将来的に復活もあり得ることが示唆されているため、項目自体は残す */}
                <wjrGrid.FlexGridColumn
                  binding="高速代請求区間"
                  isRequired={false}
                  visible={false}
                  width={400}
                  header="高速代請求区間"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="高速料税抜"
                  isRequired={false}
                  isReadOnly={true}
                  cssClassAll={"read-only-cell"}
                  width={130}
                  format="n"
                  header="高速料税抜"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="高速料税込"
                  isRequired={false}
                  width={130}
                  format="n"
                  header="高速料税込"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  isRequired={false}
                  width={300}
                  header="備考"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="AGC高速料マスタID"
                  isRequired={false}
                  isReadOnly={true}
                  width={80}
                  header="削除">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TAGC高速料GridItem>
                    ) => {
                      return (
                        <Button
                          type="button"
                          variant="caution"
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={(e) => {
                            e.preventDefault()
                            setDeleteID(context.item.AGC高速料マスタID)
                            setDelete更新日時(context.item.更新日時)
                            setIsDeleteRowConfirmModalShow(true)
                          }}>
                          削除
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
              </FlexGridOuter>
              <Button
                type="button"
                variant="waiting"
                className="ms-4"
                disabled={!isSubmitButton}
                onClick={() => {
                  // TODO:登録,Validation,
                  beforeSubmit()
                }}>
                登録
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isDeleteRowConfirmModalShow}
        hideHandler={setIsDeleteRowConfirmModalShow}
        submitHandler={deleteRow}>
        選択した行を削除しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default AGCKosokuryoTarihuRegister
